import { preferenceKeys } from "common/preferenceKeys";
import { setSecureItemSync, getSecureItemSync } from "./secureStorage";

/**
 * Profile data (contains medical info) — stored with encryption
 */
export const setProfile = (userDetails) => {
  setSecureItemSync(preferenceKeys.userProfile, userDetails);
};

export const setSecondaryProfile = (userDetails) => {
  setSecureItemSync(preferenceKeys.secondaryProfile, userDetails);
};

/**
 * Auth token — stored with encryption
 * Note: For maximum security, consider migrating to HTTP-only cookies
 * set by a server-side endpoint.
 */
export const setToken = (authToken) => {
  setSecureItemSync(preferenceKeys.authToken, authToken);
};

export const setDeviceToken_ = (token) => {
  localStorage.setItem(preferenceKeys.deviceToken, token);
};

export const getDeviceToken_ = () => {
  return localStorage.getItem(preferenceKeys.deviceToken) || "";
};

export const getToken = () => {
  // Token is stored as encrypted JSON string — getSecureItemSync returns parsed value
  const token = getSecureItemSync(preferenceKeys.authToken);
  return token || "";
};

export const getProfile = () => {
  const profile = getSecureItemSync(preferenceKeys.userProfile);
  return profile || {};
};

export const setTempUid = (tempId) => {
  localStorage.setItem(preferenceKeys.tempId, tempId);
};

export const getTempUid = () => {
  const data = localStorage.getItem(preferenceKeys.tempId);
  if (!data || data === 'undefined' || data === 'null') {
    return null;
  }
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};

export const setTempUserDetail = (userDetails) => {
  localStorage.setItem(
    preferenceKeys.tempUserData,
    JSON.stringify(userDetails)
  );
};

export const getTempUserDetail = () => {
  const data = localStorage.getItem(preferenceKeys.tempUserData);
  if (!data || data === 'undefined' || data === 'null') {
    return null;
  }
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};

export const getSecondaryProfile = () => {
  const profile = getSecureItemSync(preferenceKeys.secondaryProfile);
  if (profile) {
    return profile;
  }
  return { postalAddress: {} };
};

export const clearStorage = () => {
  let countryCode = localStorage.getItem('countryCode');
  localStorage.clear();
  if (countryCode) {
    localStorage.setItem('countryCode', countryCode);
  }
};
